/*
  A Lorinthe project.

  @Author: Tom Voorneveld <tom>
  @Date:   2019-02-27T21:24:15+01:00
  @Email:  tom@lorinthe.com
  @Project: Lorinthe
  @Last modified by:   tom
  @Last modified time: 2019-05-29T13:21:43+02:00
  @Copyright: (c) copyright Lorinthe BV, all rights reserved

  @TODO: test run, see https://github.com/vuejs/vuex/blob/dev/examples/shopping-cart/api/shop.js
*/

import Conf from '@/config/settings'
import Log from '@/lib/log'

const APP_DEFAULT = {
  language: (navigator.userLanguage || navigator.language).substr(0, 2) || 'en',
  serial_version: 0,
  currency: 'eur',
  blogpost_cache: [],
  blogpost_tags: []
}

const state = {

  // app settings, intialize from local browser storage
  app: window.localStorage.getItem('app')
    ? JSON.parse(window.localStorage.getItem('app'))
    : APP_DEFAULT,

  // stores alert message for user
  popup_message: {
    key: 'homepage.title', // key for i18n.js
    variant: 'warning' // https://bootstrap-vue.js.org/docs/components/alert/
  }
}

const getters = {

  // ** Get app setting
  // Example: mac = store.getters['app/setting']('qcode')
  setting: (state) => (param) => {
    // if no key yet, user might be using new app version,
    //   so use default for this key only
    // console.log(`get param ${param}= ${state.app[param]}`)
    return param in state.app ? state.app[param] : APP_DEFAULT[param]
  },
  // Example: alert(  store.getters['app/popup_message']()  )
  popup_message: (state) => () => {
    return state.popup_message
  }
}

// store app settings in storage after update
function storeAppSettings () {
  state.app.serial_version = Conf.serial_version
  window.localStorage.setItem('app', JSON.stringify(state.app))
}

const mutations = {
  // *** APP SETTINGS
  // Eg:  store.commit('app/setting', { set: 'location', value: false })
  setting (state, payload) {
    Log.n(`Set app.${payload.set}: "${payload.value}"`)
    state.app[payload.set] = payload.value
    storeAppSettings()
  },

  // store.commit('app/popup_message', {key: 'homepage.title', variant: 'warning')
  popup_message (state, msgObj) {
    msgObj.variant = msgObj.variant || 'info'
    state.popup_message = msgObj
  }
}

export default {
  namespaced: true,
  state,
  getters,
  // actions,
  mutations
}
